import styled from 'styled-components';
import { Text } from '@appcues/sonar';
import { easing } from 'ext/lib/style/easing';

export const AccountsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AccountName = styled.p`
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-medium);
`;

export const Account = styled.div.attrs({ role: 'button' })`
  align-items: center;
  background: var(--color-neutral-0);
  border: 1px solid var(--color-neutral-300);
  border-radius: 6px;
  box-shadow: none;
  display: flex;
  height: 64px;
  justify-content: space-between;
  max-width: 600px;
  padding: 12px var(--spacing-regular);
  cursor: pointer;
  transition: ${easing('border', 'box-shadow')};
  width: 100%;

  :hover {
    border-color: var(--color-blurple-600);
  }

  & + & {
    margin-top: 16px;
  }

  ${Text} {
    font-size: var(--font-size-small);
  }

  ${({ $selected }) =>
    $selected &&
    `
      border-color: var(--color-blurple-600);
      border-width: 2px;
      box-shadow: var(--level-2);
      transition: none;
  `}

  ${({ disabled }) =>
    disabled &&
    `
      cursor: not-allowed;

      ${AccountName}, ${Text} {
        color: var(--color-neutral-500);
      }
  `}
`;
